export default {
    DISABLED: 0,
};
